/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getRelationPairsList } from '../fn/admin-i-2-relations-controller/get-relation-pairs-list';
import { GetRelationPairsList$Params } from '../fn/admin-i-2-relations-controller/get-relation-pairs-list';
import { ItemItemRelationPairWithRelations } from '../models/item-item-relation-pair-with-relations';

@Injectable({ providedIn: 'root' })
export class AdminI2RelationsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `i2RelationControllerGetRelationPairsList()` */
  static readonly I2RelationControllerGetRelationPairsListPath = '/admin/i2-relations/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRelationPairsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRelationPairsList$Response(params?: GetRelationPairsList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemItemRelationPairWithRelations>>> {
    return getRelationPairsList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRelationPairsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRelationPairsList(params?: GetRelationPairsList$Params, context?: HttpContext): Observable<Array<ItemItemRelationPairWithRelations>> {
    return this.getRelationPairsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ItemItemRelationPairWithRelations>>): Array<ItemItemRelationPairWithRelations> => r.body)
    );
  }

}
